// @flow
import * as React from 'react';
import Helmet from 'react-helmet';

import './fonts.css';

const FontsHelmet = () => (
  <Helmet>
    {/* Custom font link. files stored in the assets folder */}
    {/*
    <link
      rel="preload"
      as="font"
      href="/fonts/Hibiscus-glitch.woff"
      type="font/woff"
      crossOrigin="anonymous"
    />
    */}
    <link
      rel="preload"
      href="https://fonts.googleapis.com/css2?family=Rajdhani:wght@600&display=swap"
      as="style"
      onLoad="this.onload=null;this.rel='stylesheet'"
    />
    <link
      rel="preload"
      href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400&display=swap"
      as="style"
      onLoad="this.onload=null;this.rel='stylesheet'"
    />
    <link rel="preconnect" href="https://fonts.gstatic.com" />
    <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css2?family=Rajdhani:wght@600&display=swap"
    />
    <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400&display=swap"
    />
  </Helmet>
);

export default FontsHelmet;
